import type { FunctionComponent} from 'react';
import React, { useState } from 'react'
import tw from 'twin.macro'
import { Minus, Plus } from '@dreamstack/icons'

export const BTLCalcAccordionBlock: FunctionComponent<React.PropsWithChildren<{
  title: string
}>> = (props) => {
  const [status, setStatus] = useState(true)

  return (
    <div>
      <div tw="flex flex-row justify-start fontWeight[600]">
        <div>
          {status && (
            <Minus
              tw="cursor-pointer mr-px-12 w-px-32 h-px-32"
              onClick={() => setStatus(false)}
            />
          )}
          {!status && (
            <Plus
              tw="cursor-pointer mr-px-12 w-px-32 h-px-32"
              onClick={() => setStatus(true)}
            />
          )}
        </div>
        <div tw="font-size[20px] font-weight[600]">{props.title}</div>
      </div>

      {status && <div tw="pt-px-12">{props.children}</div>}
      <br />
    </div>
  )
}
